import {SalaryAbility, ShiftWorkAbility} from "./BtnWorkflowAbility";

export const AbilityStore = {
    timeKeeping : ShiftWorkAbility,
    salaryTable : SalaryAbility
}